import React from "react";
import { Tag } from "antd";

import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

import { TransactionType } from "models";

interface IRoleProps {
  role: TransactionType;
}

const BatchNIBSS: React.FC<IRoleProps> = ({ role }) => {
  return (
    <React.Fragment>
      {role === "DR" ? (
        <Tag
          color="red"
          icon={<ArrowDownOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {role}
        </Tag>
      ) : role === "CR" ? (
        <Tag
          color="green"
          icon={<ArrowUpOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {role}
        </Tag>
      ) : (
        <Tag
          color="default"
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            textAlign: "center",
            display: role ? "inline" : "none",
          }}
        >
          {role}
        </Tag>
      )}
    </React.Fragment>
  );
};

export default BatchNIBSS;
